import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { appDataActions, appDataSelector } from '../../features/appDataSlice';
import { bookingSelector } from '../../features/bookingSlice';
import { getCurrencyConversionRate } from '../../utilities/APIUtilities';
import { pidEurValueSource } from '../../utilities/RulesEngineUtilities';

// Converts the shipment value to euros for the €150 PID test (spec 014 FR-001a), with the same rates the rules
// engine uses for eurShipmentValue. A failed conversion is stored as unknown (eur null), never as zero.
export function usePidEurShipmentValue() {

  const dispatch = useAppDispatch();
  const appData = useAppSelector(appDataSelector);
  const booking = useAppSelector(bookingSelector);
  const currency = booking.preferredCurrency?.value;
  const value = booking.totalShipmentValue;
  const source = pidEurValueSource(booking);

  useEffect(() => {
    if (!currency || currency === 'EUR' || value === '' || appData.pidEurShipmentValue?.source === source) return;

    let cancelled = false;
    getCurrencyConversionRate(appData.apiConfig, currency, 'EUR')
      .then(rate => {
        if (cancelled) return;
        const eur = typeof rate === 'number' && Number.isFinite(rate) && rate > 0 ? +value * rate : null;
        dispatch(appDataActions.updateField({ field: 'pidEurShipmentValue', value: { source, eur } }));
      });
    return () => { cancelled = true; };
  }, [source])
}
